import { Link } from 'react-router-dom';
import { config } from '../pages/config';
import FooterBg from '../../assets/images/Reviews.jpg';

const CTASection = () => {
  return (
    <section
      className="testimonial-section cta-banner-section"
      style={{ padding: '60px 0px' }}
    >
      <div
        className="bg-layer footer-layer"
        style={{ backgroundImage: `url(${FooterBg})`, border: '1px solid white' }}
      ></div>
      <div className="auto-container">
        <div className="row clearfix align-items-center">
          <div className="col-lg-9 col-md-8 col-sm-auto title-column">
            <div className="title-inner">
              <div className="light">
                <h3 className="text-white mb-0 cta-banner-title fw-bold ">
                  Trusted Driving School in Leicester for Over 15 Years
                </h3>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 title-inner text-lg-end text-center mt-0">
            <div className="review-box">
              <Link
                to={`${config.appUrl}get-started`}
                className="theme-btn btn-two text-nowrap"
              >
                Get started Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
